import { render, staticRenderFns } from "./Stopwordmanage.vue?vue&type=template&id=90ced492&scoped=true"
import script from "./Stopwordmanage.vue?vue&type=script&lang=js"
export * from "./Stopwordmanage.vue?vue&type=script&lang=js"
import style0 from "./Stopwordmanage.vue?vue&type=style&index=0&id=90ced492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ced492",
  null
  
)

export default component.exports